function closeSkanWidget() {
    var frameToClose = document.getElementById("sms-myframe");
    frameToClose && frameToClose.remove()
}

function openSkanWidget() {
    var myFrame = document.createElement("div");
    myFrame.setAttribute("id", "sms-myframe"), myFrame.setAttribute("style", "max-width: 1080px; width: auto; min-width: 375px; height: calc(100vh - 150px); margin: auto; overflow: hidden; box-shadow: 0 0 6px 1px #bcaaff; padding: 0; position: fixed; bottom: 13px; z-index: 9999999999; right: 12px;");
    var closeFrame = document.createElement("span");
    closeFrame.innerText = "X", closeFrame.setAttribute("style", "position: absolute;right: 28px;"), closeFrame.setAttribute("onclick", "closeSkanWidget()"), myFrame.append(closeFrame);
    var fram = document.createElement("iframe");
    fram.setAttribute("src", "https://skanmyskin.com/flow?id=121&from=shopify"), fram.setAttribute("style", "width: 100%; height: 100%;border: 0;background: white;"), myFrame.append(fram), $("body").append(myFrame)
}

$(document).ready(function () {
    $('product-grid-item-content[data-grid-item="8094990401800"]').closest("div").css("display", "none"), setTimeout(() => {
        var linkToMyCream = document.getElementById("accordion-linklist_kKALmj-4");
        if (linkToMyCream) {
            var li = document.createElement("li");
            li.setAttribute("onclick", "openSkanWidget()"), li.innerText = "Composer sa cr\xE8me", linkToMyCream.append(li)
        }
        document.querySelectorAll("a[href='/account']").forEach(a2 => {
            a2.href = "https://me.abbi.care/"
        })
    }, 6e3)


}), document.body.getAttribute("id").includes("concentre") && (document.querySelectorAll(".product__subheading")[document.querySelectorAll(".product__subheading").length - 1].style.display = "none"), $(".template-product")[0] && document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".media__thumb")[document.querySelectorAll(".media__thumb").length - 1].click(), document.querySelector("video").setAttribute("muted", "muted"), document.querySelector("video").setAttribute("autoplay", "autoplay"), document.querySelector("video").play()
}, !1), $("#coupon_code").attr("placeholder", "Code promo ou Carte cadeau"), $("button[name='apply_coupon']").text("Appliquer Code promo ou Carte cadeau");
let windowWidth = $("body").width();
$(".mkdf-logo-wrapper a").css("height", "90px");

function createMyPop() {
    $("#popUp").remove(), $("#MainContent").append(`<div class="pop-up" id="popUp" style="z-index: 10000; display: block;">
    <div class="pop_up_content mypop" id="mypop"> 
	<div class="close" onclick="getElementById('mypop').parentElement.style.display='none'">x</div>
 <div class="contain">
    <div class="left"> <div class="p-slide-img soin_ideal  p_page"></div></div>
        <div  class="right">
        	<span class="p-slide-title2 p_page">
              Le soin id\xE9al pour votre peau ?
              <br><br>
              <b>1 Base + 1, 2 ou 3<br>concentr\xE9s d'actifs</b>
              <br><br>
              Avez-vous pens\xE9 \xE0 tout ? <b>#DIY</b>
         	</span>
        	<div class="mybuttons" style="display:flex">
				<div class="button"><a href="/collections/bases">J'AJOUTE MA BASE</a></div>
				<div class="button"><a href="/collections/actifs">J'AJOUTE MES ACTIFS</a></div>
			</div>
        </div>
    </div>
	</div></div>`)
}

if ($(document).on("click", "#button_blacklist", function () {
    var html = '<iframe src="https://cdn.shopify.com/s/files/1/0664/6340/0200/files/Blacklist_Abbi.pdf?v=1677767928" width="100%" height="700px"> </iframe>';
    $("#blacklistPDF").html(html), $("#button_blacklist").hide()
}), $(document).on("click", ".product__submit__buttons", function () {
    var range = $("form.shopify-product-form").attr("data-product-handle"), isPopUp = !1;
    (range.includes("actif") || range.includes("base")) && (isPopUp = !0)
}), $(".cart__drawer .drawer__bottom__meta").html('<em>Frais de port et remises calcul\xE9s \xE0 la caisse</em><br><a href="/cart" style="text-decoration:underline">Voir le panier</a>'), $("body").attr("id") === "votre-panier") {
    $(".cart__return").html("continuer mes achats");
    var a = $(".cart__return")
}
const d = new Date;
let month = d.getMonth(), year = d.getFullYear();
month = month + 1, month < 10 && (month = "0" + month), $(document).on("click", ".ajax_add_to_cart", function () {
    const obj_id = $(this).attr("id");
    var range = $(this).attr("data-product-handle"), isPopUp = !1;
    (range.includes("ACTIF") || range.includes("BASE")) && (isPopUp = !0), isPopUp && createMyPop();
    let formData = {items: [{id: obj_id, quantity: 1}]};
    fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(formData)
    }).then(response => (isPopUp || location.reload(!0), response.json())).catch(error => {
        console.error("Error:", error)
    })
}), $("a[href='/search'] span").html('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 16 16"><path d="M16 14.864L14.863 16l-4.24-4.241a6.406 6.406 0 01-4.048 1.392 6.61 6.61 0 01-4.65-1.925A6.493 6.493 0 01.5 9.098 6.51 6.51 0 010 6.575a6.536 6.536 0 011.922-4.652A6.62 6.62 0 014.062.5 6.52 6.52 0 016.575 0 6.5 6.5 0 019.1.5c.8.332 1.51.806 2.129 1.423a6.454 6.454 0 011.436 2.13 6.54 6.54 0 01.498 2.522c0 1.503-.468 2.853-1.4 4.048L16 14.864zM3.053 10.091c.973.972 2.147 1.461 3.522 1.461 1.378 0 2.551-.489 3.525-1.461.968-.967 1.45-2.138 1.45-3.514 0-1.37-.482-2.545-1.45-3.524-.981-.968-2.154-1.45-3.525-1.45-1.376 0-2.547.483-3.513 1.45-.973.973-1.46 2.146-1.46 3.523 0 1.375.483 2.548 1.45 3.515z"></path></svg>'), $("a[href='/pages/compte-client'] span").html('<img src="https://cdn.shopify.com/s/files/1/0664/6340/0200/files/mon-espace.png?v=1674142053" alt="icon">'), $("a[href='/cart'] span").each(function () {
    $(this).html($(this).html().replace("Panier", ""))
}), $("a[href='/cart'] span .header__cart__status").before('<img src="https://cdn.shopify.com/s/files/1/0664/6340/0200/files/mon-panier.png?v=1674142406" alt="icon">'), $("input[name='username']").val("Enter Name!");
let actifs_data = [];
$.get("https://cdn.shopify.com/s/files/1/0687/0876/1800/files/products_catalog_store.json?v=1741352870", function (data) {
    actifs_data = data
}), $(".p-slide-product").click(function (e) {
    const name_class = $(this).find("input").attr("id");
    let obj_actif = actifs_data.find(a2 => a2.image_class === name_class);
    const elem = e.target;
    let p = $(elem).parents(), t = null;
    if (t = p.map((i2, a2) => {
        if ($(a2).hasClass("product-text")) return a2
    }), $("#popUp").remove(), console.log(obj_actif), t.length) {
        const buffer = `<div  class="left"> <div class="p-slide-img ${obj_actif.image_class} p_page" alt="${obj_actif.name}"></div></div>
                        <div  class="right"> <span class="p-slide-title">${obj_actif.name}</span>
                        <span class="p-slide-title2 p_page"><span>${obj_actif.description}</span>
                         <div class="button_buy"><a rel="nofollow"  class="addCart add_to_cart_button ajax_add_to_cart" data-quantity="1" data-product_id="${obj_actif.id}" id="${obj_actif.id}" data-product-handle="${obj_actif.name}" onclick="showCart()"><div class="button_apercu buy">J'ACH\xC8TE</div>
                         <div class="button_apercu buy" style="padding: 12px 8px">${obj_actif.price}\u20AC</div></a></div>
                         <div class="button"><a href="${obj_actif.url}" rel="noopener">D\xC9TAIL PRODUIT</a></div></div>`;
        $(".pop-up #contain").html(buffer), $(".pop-up").show(), $(".mkdf-page-footer").css("z-index", 1), $(".mkdf-page-header").css("z-index", 2)
    }
    $(elem).hasClass("p-slide-img") && (window.location.href = obj_actif.url)
}), $(".close").click(function () {
    $(".pop-up").hide(), $(".mkdf-page-header").css("z-index", 110)
});
var buttons_apercu = document.querySelectorAll(".button_apercu");
buttons_apercu.forEach(div => {
    var text_to_change = div.childNodes[0];
    text_to_change.nodeValue.includes("APERCU") && (text_to_change.nodeValue = "APER\xC7U")
});
var vids = $("video");
$.each(vids, function () {
    this.controls = !1
});
var objects = $(".navlink--grandchild");
for (var obj of objects) $(obj).attr("href") === "#" && ($(obj).children().css("font-weight", 700), console.log(obj));
if ($("body").hasClass("page-id-5910") && document.getElementById("right_actifs").scroll({
    top: 325,
    left: 100,
    behavior: "smooth"
}), $("body").attr("id") === "custom") {
    const urlSearchParams = new URLSearchParams(window.location.search),
        params = Object.fromEntries(urlSearchParams.entries());
    params && Object.keys(params).length && ($(".p-slide-product").hide(), Object.keys(params).forEach(key => {
        JSON.parse(params[key]) && (document.getElementById(key).checked = !0, document.querySelectorAll("#category").forEach(d2 => {
            d2.getAttribute("value").includes(key) && (d2.style.display = "flex")
        }))
    }))
}
(function () {
    let btnx = document.getElementsByClassName("accordion__title");
    for (i = 0; i < btnx.length; i++) btnx[i].textContent == `
            
          ` && (btnx[i].parentNode.style.display = "none")
})();

function showResponse(event) {
    console.log(event.target.nextElementSibling), event.target.nextElementSibling.style.display === "none" ? event.target.nextElementSibling.style.display = "block" : event.target.nextElementSibling.style.display = "none"
}

function showProductByFilter() {
    document.querySelectorAll("#category").forEach(d2 => {
        d2.style.display = "none"
    });
    let noneSel = !0;
    ["imperfections", "taches", "terne", "seche", "rides", "sensibilite"].forEach(key => {
        document.getElementById(key) && document.getElementById(key).checked && (noneSel = !1, document.querySelectorAll("#category").forEach(d2 => {
            d2.getAttribute("value").includes(key) && (d2.style.display = "flex")
        }))
    }), noneSel && document.querySelectorAll("#category").forEach(d2 => {
        d2.style.display = "flex"
    }), document.getElementById("scrollhere").scrollIntoView()
}

function goToPage(page) {
    page && (page === "custom" && (page += "?", ["imperfections", "taches", "terne", "seche", "rides", "sensibilite"].forEach(choice => {
        document.getElementById(choice) && document.getElementById(choice).checked && (page += choice + "=" + document.getElementById(choice).checked + "&")
    })), window.location.href = "/pages/" + page)
}

// function showCart() {
//     document.body.clientWidth > 480 && (setTimeout(() => {
//         document.getElementsByClassName("pop-up")[0].style.display = "none", document.getElementsByClassName("mkdf-page-header")[0].style.zIndex = 110, document.getElementsByClassName("mkdf-sc-dropdown")[0].style.maxHeight = "90vh", document.getElementsByClassName("mkdf-sc-dropdown")[0].style.overflow = "auto"
//     }, 1800), document.addEventListener("mouseup", function (e) {
//         var container = document.getElementsByClassName("mkdf-sc-dropdown")[0];
//         container.contains(e.target) || container.style.removeProperty("max-height")
//     }.bind(this)))
// }

function showDrop() {
    let x = document.getElementsByClassName("dropdown-checkbox")[0],
        xx = document.getElementsByClassName("dropdown-shadow")[0];
    window.getComputedStyle(x).display === "none" ? (x.style.display = "block", xx.style.display = "block") : (x.style.display = "none", xx.style.display = "none")
}

var links = document.links;
for (let i2 = 0, linksLength = links.length; i2 < linksLength; i2++) links[i2].hostname !== window.location.hostname && (links[i2].target = "_blank", links[i2].rel = "noreferrer noopener");
(function () {
    document.addEventListener("theme:variant:change", function (event) {
        var variant = event.detail.variant, container = event.target
    }), document.addEventListener("theme:cart:change", function (event) {
        var cart = event.detail.cart
    }), document.addEventListener("theme:cart:init", e => {
    }), document.addEventListener("theme:scroll", e => {
    }), document.addEventListener("theme:scroll:up", e => {
    }), document.addEventListener("theme:scroll:down", e => {
    }), document.addEventListener("theme:resize", e => {
    })
})();
//# sourceMappingURL=/s/files/1/0664/6340/0200/t/8/assets/custom_bis.js.map?v=1734361617

function shareIt(obj) {
  let userData = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"));
  navigator.share({title: 'ABBI Ambassador', text: 'This is my website',  url: 'https://global.abbi.care/?' + (userData ? (userData.username || '') : '')})  
    .then(() => console.log('Share successful'))  
    .catch((error) => console.error('Share failed', error));  
}

function setUserData(userData) {
    if (userData && userData.id) {
        if(userData.lastname || userData.firstname) {
            var el = document.querySelector(".top_menu");
          
            if (el) {
                let p = document.querySelector(".top_menu_1");
                p.innerHTML = '<img class="you-are-shopping-img" alt="" src="https://cdn.shopify.com/s/files/1/0687/0876/1800/files/Group_1171275065.png?v=1751437730" onclick="shareIt()"> <div class="you-are-shopping-container"> <span class="you-are-shopping">You are shopping with : </span> <span>' + ((userData.firstname || '') + ' ' + (userData.lastname || '')) + '</span> </div>';
            }
        }
        var els = document.querySelectorAll("a[href='https://ambassador.abbi.care/ambassador/register']");
        for (var i = 0, l = els.length; i < l; i++) {
            var el = els[i];
            el.href = (el.href + "?id=" + userData.id + (userData.lang ? ('&lang=' + userData.lang) : ''));
        }
        var elsflow = document.querySelectorAll("a[href='https://ambassador.abbi.care/flow']");
        for (var i = 0, l = elsflow.length; i < l; i++) {
            var el = elsflow[i];
            el.href = (el.href + "?id=" + userData.id + '&started=true' + (userData.lang ? ('&lang=' + userData.lang) : ''));
        }
        var elsAmbflow = document.querySelectorAll("a[href='https://ambassador.abbi.care/ambassador-flow']");
        for (var i = 0, l = elsAmbflow.length; i < l; i++) {
            var el = elsAmbflow[i];
            el.href = (el.href + "?id=" + userData.id + (userData.lang ? ('&lang=' + userData.lang) : ''));
        }
    }
}

function getUserData() {
    let username = window.location.href.includes('?') && window.location.href.split('?').pop().split('&')[0];
    if(username) {
        let xhr = new XMLHttpRequest();
        xhr.open("GET", "https://api.skanmyskin.com/profiles/username/" + username, false);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send();
        if (xhr.status === 200) {
            let response = JSON.parse(xhr.responseText);
            if(response && response.id) {
                let userData = response;

                let lang = '';
                if(userData.lang) {
                    if(userData.lang === 'french') {
                        lang = 'fr';
                    } else if(userData.lang === 'germen') {
                        lang = 'de';
                    } else if(userData.lang === 'spanish') {
                        lang = 'es';
                    }
                }

                if(lang && !window.location.href.includes('/' + lang)) {
                    window.location.href = ('/' + lang + '?' + username);
                    return;
                }

                setUserData(userData);
                localStorage.setItem("userData", JSON.stringify(Object.assign(userData, {username})));
                if(typeof localStorage === 'undefined') {
                    setUserData({id: 64854, lastname: "Storage_write_error"});
                }
            }
        } else {
            console.error("Error fetching user data");
        }
    } else {
        let userData = localStorage.getItem("userData");
        if(typeof localStorage === 'undefined') {
            userData = JSON.stringify({id: 64854, lastname: "Storage_write_error"});
        }
        if (userData) {
            setUserData(JSON.parse(userData));
        } else {

        }
    }
}



$(document).ready(function () {
    window.location.href = 'https://global.abbi.care';
    return;
    setTimeout(() => {
        var els = document.querySelector("#localization-form-footer");
        els.remove();
        
   
        getUserData();

        let slide = document.querySelector('#heroSectionContainer');
let slide1 = document.querySelector('#heroSectionContainer2');
setInterval(() => {
    if(slide) {
      slide.style.display = 'none';
      slide1.style.display = 'block';
    }
}, 5000);
setInterval(() => {
    if(slide1) {
      slide1.style.display = 'none';
      slide.style.display = 'block';
    }
}, 10000);


            let lang;
    if(window.location.href.includes('/fr')) {
        lang = 'fr';
    }
if(window.location.href.includes('/es')) {
        lang = 'es';
    }
if(window.location.href.includes('/de')) {
        lang = 'de';
    }
      
      var anchors = document.querySelectorAll("a");

      for (var i = 0; i < anchors.length; i++) {
        if(anchors[i].href.includes(`https://${location.host}`) && lang && !anchors[i].href.includes(`/${lang}`))
          anchors[i].href = anchors[i].href.replace(`https://${location.host}`, `https://${location.host}/${lang}`);
      }
            
      
       const selected = document.getElementById('selected-lang');
  const options = document.getElementById('lang-options');

  selected.addEventListener('click', () => {
    options.style.display = options.style.display === 'block' ? 'none' : 'block';
  });

  document.querySelectorAll('.lang-option').forEach(opt => {
    opt.addEventListener('click', () => {
      const url = opt.getAttribute('data-url');
      window.location.href = url;
    });
  });

  document.addEventListener('click', (e) => {
    if (!document.getElementById('lang-switcher').contains(e.target)) {
      options.style.display = 'none';
    }
  });
      
    }, 1000);
});